function dadosPlaca({dadosPlaca}){
    return (
        <div class="container" style={{marginBottom: '8%;', display: 'none'}}>
            <form style={{marginTop:'0', paddingTop:'0'}}>
                <div class="col-md-12">
                    <div class="tab-content" id="PesquisaResult">
                        <div role="tabpanel" class="tab-pane active" id="home">
                            <div class="table-responsive">
                                <table id="result" class="table table-bordred table-striped">
                                    <thead>
                                        <tr>
                                            <th>Placa</th>
                                            <th>Proprietario</th>
                                            <th>Chassi</th>
                                            <th>Cor</th>
                                            <th>Renavam</th>
                                            <th>Modelo</th>
                                            <th>Ano/Modelo</th>
                                            <th>Cidade/UF</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{dadosPlaca.placa}</td>
                                            <td><a href={`/Resultado/`+dadosPlaca.doc}>{dadosPlaca.proprietario}</a></td>
                                            <td>{dadosPlaca.chassi}</td>
                                            <td>{dadosPlaca.cor}</td>
                                            <td>{dadosPlaca.renavam}</td>
                                            <td>{dadosPlaca.modelo}</td>
                                            <td>{dadosPlaca.ano_modelo}</td>
                                            <td>{dadosPlaca.uf}</td>
                                            </tr>
                                    </tbody>
                                </table>                                
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default dadosPlaca;